import React, { useEffect, useState } from "react";
import SectionTitle from "../layout/SectionTitle";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { useTranslation } from 'react-i18next';
import Slider from "react-slick";
import styled from 'styled-components';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Conteneur stylé pour le slider des partenaires
const PartnersContainer = styled.div`
  .slick-track {
    display: flex;
    align-items: center;
  }
  
  .partner-card {
    transition: all 0.3s ease;
    filter: grayscale(0%);
    opacity: 1;
    
    &:hover {
      transform: scale(1.05);
    }
  }
  
  .slick-slide {
    margin: 0 10px;
  }
  
  .slick-list {
    margin: 0 -10px;
    overflow: hidden;
  }
`;

export default function Partenaires() {
  const { t } = useTranslation();
  const [sectionRef, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });

  // Get partners from translations
  const partners = t('home.partners.list', { returnObjects: true });
  
  // Duplicate partners for infinite loop effect
  const [slidesToShow, setSlidesToShow] = useState(4);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 640) {
        setSlidesToShow(1);
      } else if (window.innerWidth < 768) {
        setSlidesToShow(2);
      } else if (window.innerWidth < 1024) {
        setSlidesToShow(3);
      } else {
        setSlidesToShow(4);
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 15000,
    slidesToShow: slidesToShow,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: "linear",
    pauseOnHover: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  };

  return (
    <section className="py-8 bg-white" ref={sectionRef} id="partenaires">
      <div className="container mx-auto px-4">
        <div className="mb-10">
          <SectionTitle
            overline={t('home.partners.title')}
            highlight={t('home.partners.highlight')}
            showLogo={true}
            align="left"
          />
        </div>

        {/* Partners Carousel */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={inView ? { opacity: 1 } : {}}
          transition={{ delay: 0.4, duration: 0.8 }}
          className="mt-12"
        >
          <PartnersContainer>
            <div className="py-8 px-4 overflow-hidden bg-white">
              
              <Slider {...sliderSettings} className="partners-slider">
                {/* First set */}
                {partners.map((partner, index) => (
                  <div key={`first-${index}`} className="px-4">
                    <div className="partner-card bg-white p-6 flex items-center justify-center h-28">
                      <img 
                        src={partner.logo} 
                        alt={partner.name} 
                        className="max-h-16 max-w-full" 
                      />
                    </div>
                  </div>
                ))}
                {/* Duplicate set for seamless loop */}
                {partners.map((partner, index) => (
                  <div key={`second-${index}`} className="px-4">
                    <div className="partner-card bg-white p-6 flex items-center justify-center h-28">
                      <img 
                        src={partner.logo} 
                        alt={partner.name} 
                        className="max-h-16 max-w-full" 
                      />
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          </PartnersContainer>
        </motion.div>
      </div>
    </section>
  );
}
